export default "__VITE_ASSET__DT5he7dP__"